<app-input-modal />
<router-outlet />
@if (false) {
  <app-debug-info />
}
